module.exports = __webpack_public_path__ + "img/d.66b59fd8.jpg";